import { RgiRealEstateFormValues, UpiRealEstateFormValues } from '../types/realEstateFormValues';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { rgiRealEstateValidationRules, upiRealEstateValidationRules } from './realEstateValidationRules';
import { PropertyTypeEnum, RentalTypeEnum } from 'api/real-estate';
import { RealEstateFormFieldNames } from '../types/realEstateFormFieldNames';

const upiRealEstateFormConfig = createFormConfig<UpiRealEstateFormValues>(
  upiRealEstateValidationRules as ValidationRules<keyof UpiRealEstateFormValues>,
  {
    [RealEstateFormFieldNames.Photo]: null,
    [RealEstateFormFieldNames.PropertyType]: PropertyTypeEnum.Apartment,
  }
);

const rgiRealEstateFormConfig = createFormConfig<RgiRealEstateFormValues>(
  rgiRealEstateValidationRules as ValidationRules<keyof RgiRealEstateFormValues>,
  {
    [RealEstateFormFieldNames.Photo]: null,
    [RealEstateFormFieldNames.PropertyType]: PropertyTypeEnum.Apartment,
    [RealEstateFormFieldNames.RentalType]: RentalTypeEnum.NotForRent,
  }
);

export { upiRealEstateFormConfig, rgiRealEstateFormConfig };
